export enum AppLanguage {
  ru = 'ru',
  en = 'en',
}
